/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryHook} from '../types'
import {getBrandProfile} from '../api'

 export const useQueryGetBrandProfile = createReactQueryHook('getBrandProfile', getBrandProfile)
